import { render, staticRenderFns } from "./FreeCanoeAndKayakEvents.vue?vue&type=template&id=d9ae591e&scoped=true&"
import script from "./FreeCanoeAndKayakEvents.vue?vue&type=script&lang=js&"
export * from "./FreeCanoeAndKayakEvents.vue?vue&type=script&lang=js&"
import style0 from "./FreeCanoeAndKayakEvents.vue?vue&type=style&index=0&id=d9ae591e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ae591e",
  null
  
)

export default component.exports